import { FaceRecognition } from "./../../services/face_recognition";

export const state = {};

export const mutations = {};

export const getters = {};

export const actions = {
  imageEnroll({}, { image }) {
    return FaceRecognition.enroll({ image });
  },

  imageRecognize({}, { image }) {
    return FaceRecognition.recognize({ image });
  }
};
